!function(){
  "use strict";

  if(!/^\/products\//.test(window.location.pathname))return;

  var MONATE=[1,2,3,4,5,6,12];
  var BADGES={3:"BESTSELLER",6:"HALBJAHRES-HIT",12:"JAHRES-VORTEIL"};
  var rootTimer=0;

  function assetBase(){
    var scripts=document.scripts;
    for(var i=0;i<scripts.length;i+=1){
      var src=scripts[i].src||"";
      if(/\/mm-aboplatz-auswahl-v7\.js(?:\?|$)/.test(src))return src.slice(0,src.lastIndexOf("/")+1);
    }
    return "/cdn/shop/t/29/assets/";
  }

  var base=assetBase();
  var productImages={
    standard:base+"mm-abo-stick-standard.png",
    strawberry:base+"mm-abo-stick-strawberry.png",
    florea:base+"mm-abo-stick-florea.png",
    nuss:base+"mm-abo-stick-nuss.png"
  };

  var css=[
    ".mmAboEng{--mmAboAccent:#315c43;--mmAboAccentSoft:#edf4ef;box-sizing:border-box;margin:15px 0 16px!important;max-width:100%!important;padding:0!important;background:transparent!important;color:#151013!important;overflow:visible!important}",
    ".mmAboEng *{box-sizing:border-box;min-width:0}",
    ".mmAboEng fieldset,.mmAboEng .shopify_subscriptions_fieldset{min-inline-size:0!important;min-width:0!important;width:100%!important;margin:0!important;padding:0!important;border:0!important}",
    ".mmAboEng .shopify_subscriptions_fieldset{position:relative!important;margin:19px 0 0!important;padding:21px 0 0!important;border-top:1px solid rgba(21,16,19,.28)!important;overflow:visible!important}",
    '.mmAboEng .shopify_subscriptions_fieldset:before{content:"Wähle deine Kaufoption";position:absolute;top:-13px;left:50%;transform:translateX(-50%);padding:0 10px;background:rgba(255,255,255,.92);color:#151013;white-space:nowrap;font-family:"MM Poppins","MM Bricolage",sans-serif;font-weight:900;font-size:.86rem;line-height:1.2;letter-spacing:-.015em}',
    ".mmAboEng .plan_card{display:grid!important;grid-template-columns:1fr!important;gap:9px!important;width:100%!important;margin:0!important;padding:0!important;border:0!important;background:transparent!important;color:#151013!important}",
    ".mmAboEng .subscription_group{position:relative!important;display:block!important;width:100%!important;min-width:0!important;margin:0!important;padding:12px 14px!important;border:1.5px solid rgba(21,16,19,.18)!important;border-radius:18px!important;background:#fff!important;color:#151013!important;transition:border-color .28s ease,box-shadow .28s ease,transform .28s ease!important}",
    ".mmAboEng .subscription_group[data-mm-abo-alt]{display:none!important}",
    ".mmAboEng .subscription_group:has(input:checked){border-color:#151013!important;box-shadow:0 4px 16px rgba(21,16,19,.09)!important}",
    ".mmAboEng .subscription_group.mmAboReal{padding:14px 14px 13px!important;border-color:rgba(21,16,19,.24)!important}",
    ".mmAboEng .subscription_group.mmAboReal:has(input:checked){border-color:#151013!important;box-shadow:0 5px 18px rgba(21,16,19,.12)!important}",
    ".mmAboEng .subscription_group.mmAboReal>.title_and_price_wrapper{display:flex!important;align-items:flex-start!important;justify-content:space-between!important;gap:12px!important;width:100%!important;margin:0!important;padding:0!important}",
    ".mmAboEng .subscription_group.mmAboReal>.title_and_price_wrapper .group_name{display:block!important;margin:0!important;color:#151013!important;font-family:\"MM Poppins\",\"MM Bricolage\",sans-serif!important;font-size:1rem!important;font-weight:900!important;line-height:1.16!important;letter-spacing:-.025em!important}",
    ".mmAboEng .subscription_group.mmAboReal>.title_and_price_wrapper:after{content:'30 Sticks pro Lieferung';display:block!important;margin-left:auto!important;padding-top:1px!important;color:rgba(21,16,19,.6)!important;font-family:\"MM Poppins\",\"MM Bricolage\",sans-serif!important;font-size:.7rem!important;font-weight:700!important;line-height:1.3!important;white-space:nowrap!important}",
    ".mmAboEng .subscription_group[data-mm-abo-alt] .group_list,.mmAboEng .subscription_group.mmAboReal>.group_list{display:none!important}",
    ".mmAboEng .subscription_group .custom_radio_button input{position:absolute!important;width:1px!important;height:1px!important;margin:0!important;padding:0!important;clip:rect(0 0 0 0)!important;clip-path:inset(50%)!important;white-space:nowrap!important;border:0!important;opacity:0!important;pointer-events:none!important}",
    ".mmAboEng .subscription_group .custom_radio_button:before,.mmAboEng .subscription_group .custom_radio_button:after{content:none!important;display:none!important}",
    ".mmAboEng .one_time_purchase_option_app_block.custom_radio_button{display:flex!important;align-items:center!important;gap:10px!important;margin:0!important;padding:0!important;cursor:pointer!important}",
    ".mmAboEng .subscription_group:not(.mmAboReal)>.title_and_price_wrapper{display:flex!important;align-items:center!important;justify-content:space-between!important;gap:10px!important;width:100%!important;margin:0!important;padding:0!important}",
    ".mmAboEng .subscription_group:not(.mmAboReal) .one_time_purchase_option_app_block span,.mmAboEng .subscription_group:not(.mmAboReal) .group_name{display:block!important;margin:0!important;color:#151013!important;font-family:\"MM Poppins\",\"MM Bricolage\",sans-serif!important;font-size:.96rem!important;font-weight:900!important;line-height:1.25!important;letter-spacing:-.02em!important}",
    ".mmAboEng .in_widget_price{display:block!important;flex:0 0 auto!important;margin:0!important;padding:0!important;color:#151013!important;font-family:\"MM Poppins\",\"MM Bricolage\",sans-serif!important;font-size:.92rem!important;font-weight:900!important;line-height:1.2!important;white-space:nowrap!important}",
    ".mmAboEng .shopify_subscriptions_app_block--hidden{visibility:visible!important;opacity:1!important}",
    ".mmAboEng [class*=polic]{display:block!important;width:100%!important;max-width:100%!important;margin:10px 2px 0!important;padding:0!important;color:rgba(21,16,19,.58)!important;font-size:.65rem!important;line-height:1.4!important;text-align:center!important;opacity:1!important;white-space:normal!important;overflow-wrap:anywhere!important}",
    ".mmAboEng .mmAboMengenwahl{display:block!important;width:100%!important;margin:12px 0 0!important;padding:0!important}",
    ".mmAboEng .mmAboMengenToggle{display:flex!important;align-items:center!important;justify-content:space-between!important;gap:10px!important;width:100%!important;min-height:38px!important;margin:0!important;padding:9px 11px!important;border:1px solid rgba(21,16,19,.17)!important;border-radius:12px!important;background:#faf9fa!important;color:#151013!important;font-family:\"MM Poppins\",\"MM Bricolage\",sans-serif!important;font-size:.72rem!important;font-weight:900!important;line-height:1.2!important;text-align:left!important;cursor:pointer!important;appearance:none!important;-webkit-appearance:none!important;transition:border-color .2s ease,background .2s ease!important}",
    ".mmAboEng .mmAboMengenToggle:hover{border-color:rgba(21,16,19,.52)!important;background:#fff!important}",
    ".mmAboEng .mmAboMengenToggleTitel{flex:0 0 auto!important}",
    ".mmAboEng .mmAboMengenAktuell{margin-left:auto!important;color:rgba(21,16,19,.66)!important;font-weight:800!important;white-space:nowrap!important}",
    ".mmAboEng .mmAboChevron{width:7px!important;height:7px!important;flex:0 0 7px!important;margin:0 2px 3px 0!important;border-right:2px solid #151013!important;border-bottom:2px solid #151013!important;transform:rotate(45deg)!important;transition:transform .22s ease!important}",
    ".mmAboEng .subscription_group.mmAboMengenOffen .mmAboChevron{transform:rotate(225deg)!important}",
    /* 28.08.2026, Mert: "Monatsvorrat im Abo drueckt, soll Vorrat waehlen
       kommen. Gelistet mit Animation."
       Vorher schaltete das Panel nur `display` um - das laesst sich nicht
       animieren, es war einfach da oder weg. Jetzt bleibt es immer im
       Raster und faehrt ueber Hoehe und Deckkraft auf; die Kacheln laufen
       einzeln nach. `grid-template-rows` von 0fr auf 1fr ist der einzige
       Weg, eine unbekannte Hoehe sauber zu animieren - eine feste
       max-height muesste geraten werden und wuerde bei anderer Kachelzahl
       springen. */
    ".mmAboEng .mmAboMengenOption{position:relative!important;display:flex!important;flex-direction:column!important;align-items:flex-start!important;justify-content:flex-start!important;min-width:0!important;min-height:91px!important;margin:0!important;padding:11px 9px 9px!important;border:1px solid rgba(21,16,19,.18)!important;border-radius:12px!important;background:#fff!important;color:#151013!important;font-family:\"MM Poppins\",\"MM Bricolage\",sans-serif!important;text-align:left!important;cursor:pointer!important;appearance:none!important;-webkit-appearance:none!important;overflow:visible!important;transition:border-color .2s ease,background .2s ease,transform .2s ease,box-shadow .2s ease!important}",
    ".mmAboEng .mmAboMengenOption:hover{border-color:rgba(21,16,19,.52)!important;transform:translateY(-1px)!important}",
    ".mmAboEng .mmAboMengenOption.mmAboMengenAktiv{border:2px solid #151013!important;padding:10px 8px 8px!important;background:var(--mmAboAccentSoft,#edf4ef)!important;box-shadow:0 3px 9px rgba(21,16,19,.1)!important}",
    ".mmAboEng .mmAboMengenOption strong{display:block!important;max-width:100%!important;padding:0!important;color:#151013!important;font-size:.72rem!important;font-weight:900!important;line-height:1.12!important;white-space:nowrap!important}",
    ".mmAboEng .mmAboMengenOption .mmAboSticks{display:block!important;max-width:100%!important;margin-top:5px!important;color:rgba(21,16,19,.64)!important;font-size:.61rem!important;font-weight:700!important;line-height:1.18!important;white-space:normal!important;overflow-wrap:normal!important}",
    ".mmAboEng .mmAboMengenOption .mmAboRabatt{display:block!important;margin-top:auto!important;padding-top:6px!important;color:var(--mmAboAccent,#315c43)!important;font-size:.62rem!important;font-weight:900!important;line-height:1.1!important;white-space:nowrap!important}",
    ".mmAboEng .mmAboMengenOption .mmAboPreis{display:block!important;max-width:100%!important;margin-top:5px!important;color:rgba(21,16,19,.62)!important;font-size:.58rem!important;font-weight:800!important;line-height:1.1!important;white-space:normal!important;overflow-wrap:normal!important}",
    ".mmAboEng .mmAboMengenOption[data-mm-badge]:before{content:attr(data-mm-badge);position:absolute!important;top:-9px!important;right:7px!important;padding:4px 7px!important;border-radius:999px!important;background:#151013!important;color:#fff!important;font-size:.47rem!important;font-weight:900!important;line-height:1!important;letter-spacing:.02em!important;white-space:nowrap!important;box-shadow:0 3px 8px rgba(21,16,19,.2)!important;background-image:linear-gradient(110deg,transparent 0%,transparent 42%,rgba(255,255,255,.36) 50%,transparent 58%,transparent 100%)!important;background-size:240% 100%!important}",
    ".mmAboEng .mmAboMengenOption[data-mm-badge]{padding-top:13px!important}",
    ".mmAboEng .mmAboMengenOption.mmAboMengenAktiv[data-mm-badge]{padding-top:12px!important}",
    ".mmAboEng .mmAboMengenOption:focus-visible,.mmAboEng .mmAboMengenToggle:focus-visible{outline:3px solid #E5142A!important;outline-offset:3px!important}",
    "@keyframes mmAboBadgeGlanz{from{background-position:180% 0}to{background-position:-45% 0}}",
    ".mmAboAnimBereit:not(.mmAboAnimAn) .shopify_subscriptions_fieldset:before,.mmAboAnimBereit:not(.mmAboAnimAn) .subscription_group{opacity:0!important}",
    ".mmAboAnimBereit:not(.mmAboAnimAn) .subscription_group{transform:translateY(12px)!important}",
    ".mmAboAnimAn .shopify_subscriptions_fieldset:before{animation:mmAboTitelRein .35s cubic-bezier(.22,.61,.36,1) both}",
    ".mmAboAnimAn .subscription_group{animation:mmAboKarteRein .45s cubic-bezier(.22,.61,.36,1) var(--mmAboVerzug,.08s) both}",
    ".mmAboAnimAn .mmAboMengenOption[data-mm-badge]:before{animation:mmAboBadgeGlanz 2.2s linear .42s infinite}",
    "@keyframes mmAboTitelRein{from{opacity:0;transform:translate(-50%,7px)}to{opacity:1;transform:translate(-50%,0)}}",
    "@keyframes mmAboKarteRein{from{opacity:0;transform:translateY(12px);filter:blur(2px)}to{opacity:1;transform:translateY(0);filter:blur(0)}}",
    "@media(max-width:560px){.mmAboEng .subscription_group.mmAboReal>.title_and_price_wrapper:after{font-size:.62rem!important}.mmAboEng .mmAboMengenPanel{grid-template-columns:repeat(2,minmax(0,1fr))!important;gap:6px!important}.mmAboEng .mmAboMengenOption{min-height:86px!important;padding:10px 9px 8px!important}.mmAboEng .mmAboMengenOption strong{font-size:.69rem!important}.mmAboEng .mmAboMengenOption .mmAboSticks{font-size:.59rem!important}.mmAboEng .mmAboMengenOption .mmAboRabatt{font-size:.59rem!important}.mmAboEng .mmAboMengenOption .mmAboPreis{font-size:.56rem!important}}",
    "@media(max-width:420px){.mmAboEng .subscription_group{padding:11px 12px!important}.mmAboEng .subscription_group.mmAboReal{padding:12px!important}.mmAboEng .subscription_group.mmAboReal>.title_and_price_wrapper{display:block!important}.mmAboEng .subscription_group.mmAboReal>.title_and_price_wrapper:after{margin:4px 0 0!important;font-size:.64rem!important}.mmAboEng .mmAboMengenToggle{font-size:.68rem!important}.mmAboEng .mmAboMengenAktuell{font-size:.61rem!important}.mmAboEng .mmAboMengenOption{min-height:84px!important}}",
    "@media(prefers-reduced-motion:reduce){.mmAboEng .shopify_subscriptions_fieldset:before,.mmAboEng .subscription_group,.mmAboEng .mmAboMengenOption[data-mm-badge]:before{animation:none!important;transition:none!important;opacity:1!important;filter:none!important}.mmAboEng .mmAboMengenOption:hover{transform:none!important}}",
    ".mmBestsellerFarbe{background:#151013!important;background-image:none!important;color:#fff!important;border:0!important;outline:0!important;box-shadow:none!important;opacity:0;transform:translate3d(-18px,0,0);transition:opacity .42s ease,transform .58s cubic-bezier(.22,.61,.36,1)}",
    ".mmBestsellerFarbe.mmBestsellerDa{opacity:1;transform:translate3d(0,0,0)}",
    "@media(prefers-reduced-motion:reduce){.mmBestsellerFarbe{opacity:1;transform:none;transition:none}}",
    "#mmFaq2 .mmF2kopf h2,#mmFaq2 .mmF2kopf h2 *{color:#F3E9EC!important;background:none!important;background-image:none!important;-webkit-text-fill-color:#F3E9EC!important}",
    "#mmFaq2 .mmF2avatare,#mmFaq2 .mmF2avatare *{color:rgba(243,233,236,.8)!important}",
    "#mmFaq2 .mmF2knopf{color:rgba(243,233,236,.82)!important;border-color:rgba(243,233,236,.24)!important}",
    "#mmFaq2 .mmF2frage,#mmFaq2 .mmF2frage *,#mmFaq2 .mmF2plus{color:rgba(243,233,236,.92)!important}",
    "#mmFaq2 .mmF2feld{background:rgba(243,233,236,.045)!important;border-color:rgba(243,233,236,.22)!important}",
    "#mmFaq2 .mmF2inhalt,#mmFaq2 .mmF2inhalt p,#mmFaq2 .mmF2inhalt li{color:rgba(243,233,236,.82)!important}",
    "#mmFaq2 .mmF2inhalt strong{color:#F3E9EC!important}",
    ".mmAboEng[data-mm-abo-set]{display:none!important}"
  ].join("");

  function addStyle(){
    if(document.getElementById("mm-aboplatz-stil-v7"))return;
    var style=document.createElement("style");
    style.id="mm-aboplatz-stil-v7";
    style.textContent=css;
    (document.head||document.documentElement).appendChild(style);
  }

  function sortKey(){
    var h=document.querySelector("main h1");
    var text=(window.location.pathname+" "+document.title+" "+(h?h.textContent:" ")).toLowerCase();
    if(/magic-fruit|florea/.test(text))return"florea";
    if(/zero-termo|zerotermo|nuss|pro.?milk/.test(text))return"nuss";
    if(/erdbeer|strawberry/.test(text))return"strawberry";
    return"standard";
  }

  function isSetPage(){
    var h=document.querySelector("main h1");
    var text=(window.location.pathname+" "+document.title+" "+(h?h.textContent:" ")).toLowerCase();
    return /(^|[-\s])(set|sets|2er|3er|4er|5er|6er|bundle|paket|duo|trio)([-\s]|$)/.test(text);
  }

  function planText(input){
    var label=input.closest("label");
    var text=(input.getAttribute("aria-label")||label&&label.textContent||"").replace(/\s+/g," ").trim();
    text=text.replace(/\. Produktpreis.*$/i,"").trim();
    return text;
  }

  function money(input){
    var raw=input.getAttribute("data-variant-price")||"";
    if(!raw){
      var label=input.closest("label");
      var price=label&&label.querySelector(".in_widget_price");
      raw=price?price.textContent:"";
    }
    return raw.replace(/\s+/g," ").trim();
  }

  function details(input){
    var text=planText(input);
    var year=/1\s*Jahr/i.test(text);
    var months=year?12:parseInt((text.match(/(\d+)\s*Monat/i)||[])[1]||"1",10);
    var deliveries=parseInt((text.match(/(\d+)\s*Liefer/i)||[])[1]||String(months),10);
    var discount=parseInt((text.match(/(\d+)\s*%/)||[])[1]||"0",10);
    var title=year?"1 Jahr":months+" "+(months===1?"Monat":"Monate");
    return {input:input,id:input.getAttribute("data-selling-plan-id")||"",text:text,months:months,deliveries:deliveries,discount:discount,title:title,price:money(input)};
  }

  function findRealGroup(container){
    var groups=Array.prototype.slice.call(container.querySelectorAll(".subscription_group"));
    return groups.find(function(group){return group.querySelectorAll('input[data-radio-type="selling_plan"]').length===7||group.querySelectorAll('input[data-radio-type="selling_plan"]').length>=7;})||null;
  }

  function findSubscriptionRoot(){
    return document.querySelector(".shopify_subscriptions_app_container");
  }

  function setAccent(container){
    var key=sortKey();
    var colors={standard:["#d86b22","#fff3e9"],strawberry:["#d6204d","#fff0f4"],nuss:["#315c43","#edf4ef"],florea:["#b13e74","#fff0f6"]};
    var pair=colors[key]||colors.standard;
    container.style.setProperty("--mmAboAccent",pair[0]);
    container.style.setProperty("--mmAboAccentSoft",pair[1]);
    container.style.setProperty("--mmAboBild",'url("'+productImages[key]+ '")');
  }

  function syncCardState(group,panel,toggleValue){
    var active=group.querySelector('input[data-radio-type="selling_plan"]:checked');
    var activeId=active&&active.getAttribute("data-selling-plan-id")||"";
    var activeData=active?details(active):null;
    panel.querySelectorAll(".mmAboMengenOption").forEach(function(card){
      var yes=card.getAttribute("data-mm-plan-id")===activeId;
      card.classList.toggle("mmAboMengenAktiv",yes);
      card.setAttribute("aria-pressed",yes?"true":"false");
    });
    if(activeData)toggleValue.textContent=activeData.title+" · "+activeData.deliveries+" Lieferung"+(activeData.deliveries===1?"":"en");
    else toggleValue.textContent="Laufzeit auswählen";
  }

  /* 28.08.2026 GEMESSEN: Die App legt DREI `.subscription_group` an, von denen
     nur eine sichtbar ist - die anderen stehen auf `display:none`. Wurde die
     Klasse nur auf "die eigene" Gruppe gesetzt, landete sie regelmaessig auf
     einer versteckten: Das Raster ging brav auf 1fr, zu sehen war aber nichts,
     und das sichtbare Panel blieb bei `opacity:0`.
     Deshalb wird der Zustand auf ALLE Gruppen mit Mengenwahl gesetzt. Sichtbar
     ist ohnehin nur eine; die versteckten stoert es nicht. */
  function openPanel(group,toggle,open){
    var gruppen=document.querySelectorAll(".mmAboEng .subscription_group");
    for(var i=0;i<gruppen.length;i++){
      if(!gruppen[i].querySelector(".mmAboMengenwahl"))continue;
      gruppen[i].classList.toggle("mmAboMengenOffen",open);
    }
    var knoepfe=document.querySelectorAll(".mmAboEng .mmAboMengenToggle");
    for(var k=0;k<knoepfe.length;k++){
      knoepfe[k].setAttribute("aria-expanded",open?"true":"false");
    }
  }

  /* 28.08.2026, Mert: "Monatsvorrat im Abo drueckt, soll Vorrat waehlen kommen.
     Gelistet mit Animation."
     Vorher klappte die Laufzeit-Auswahl von selbst auf, 720 ms nachdem sie ins
     Bild kam - unabhaengig davon, ob ueberhaupt das Abo gewaehlt war. Wer
     "Einmaliger Kauf" wollte, bekam die Laufzeiten trotzdem vorgesetzt.
     Jetzt haengt das Aufklappen an der Entscheidung: Abo gewaehlt -> auf,
     Einmalkauf -> zu. Der Knopf "Vorrat waehlen" bleibt zusaetzlich von Hand
     bedienbar; wer ihn selbst benutzt, behaelt die Kontrolle, bis er die
     Kaufoption wechselt. */
  /* 28.08.2026 GEMESSEN, nachdem der erste Versuch nicht ausloeste:
     Die App legt NICHT zwei Gruppen an (Einmalkauf / Abo), sondern EINE
     Radiogruppe mit neun Eintraegen, alle mit demselben `name` und alle
     innerhalb von `.subscription_group`:
       0  "Einmaliger Kauf"
       1  "Zustellung jeden Monat, 5 % Rabatt"   <- Abo-Einstieg
       2-8 die Laufzeiten (1 Monat bis 1 Jahr)
     Eine Pruefung auf "ist in meiner Gruppe etwas gewaehlt" konnte deshalb nie
     zwischen Einmalkauf und Abo unterscheiden - sie war immer wahr.
     Erkannt wird jetzt am Eintrag selbst: Wer den Einmalkauf gewaehlt hat,
     bekommt die Laufzeiten nicht; jede andere Wahl ist ein Abo. */
  function istEinmalkauf(radio){
    if(!radio)return false;
    var umfeld=radio.closest("label")||radio.parentElement;
    var txt=(umfeld&&umfeld.textContent||"").toLowerCase();
    return txt.indexOf("einmalig")>-1||txt.indexOf("one-time")>-1||
           txt.indexOf("one time")>-1||txt.indexOf("einmaliger kauf")>-1;
  }

  function abogewaehlt(){
    var alle=document.querySelectorAll(".mmAboEng input[type=radio]");
    for(var i=0;i<alle.length;i++){
      if(alle[i].checked)return !istEinmalkauf(alle[i]);
    }
    return false;
  }

  /* 29.08.2026, Mert: "das darf nicht so sein das sieht dumm aus und nimmt viel
     platz - immer eingeklappt lassen / und dann wenn man drauf drueckt soll er
     ausklappen."
     Hier sass das automatische Aufklappen: Sobald ein Abo gewaehlt war, ging die
     Laufzeit-Liste von selbst auf. Der Umbau im Altdesign konnte das nicht
     verhindern, weil der Zustand VON HIER kommt. Geblieben ist nur noch das
     Zuklappen beim Wechsel der Kaufoption - ein offener Block ueber
     "Einmaliger Kauf" haette keinen Zweck. Geoeffnet wird ausschliesslich ueber
     den Knopf "Vorrat waehlen" (Handler in createChoices). */
  function installAutoOpen(group,toggle){
    if(group.dataset.mmAboAutoOpen)return;
    group.dataset.mmAboAutoOpen="1";

    document.addEventListener("change",function(e){
      var t=e.target;
      if(!t||t.type!=="radio"||!t.closest)return;
      if(!t.closest(".mmAboEng"))return;
      if(t.closest(".mmAboMengenPanel"))return;
      openPanel(group,toggle,false);
    });

    openPanel(group,toggle,false);
  }

  function createChoices(group,plans){
    if(group.querySelector(".mmAboMengenwahl"))return group.querySelector(".mmAboMengenwahl");
    var wrap=document.createElement("div");
    wrap.className="mmAboMengenwahl";
    var toggle=document.createElement("button");
    toggle.type="button";
    toggle.className="mmAboMengenToggle";
    toggle.setAttribute("aria-expanded","false");
    toggle.innerHTML='<span class="mmAboMengenToggleTitel">Vorrat wählen</span><span class="mmAboMengenAktuell">Laufzeit auswählen</span><span class="mmAboChevron" aria-hidden="true"></span>';
    wrap.appendChild(toggle);
    /* Fuer die Hoehen-Animation braucht das Raster ein Kind, das ueberlaufen
       darf - sonst kann 0fr die Hoehe nicht zusammenziehen. */
    var huelle=document.createElement("div");
    huelle.className="mmAboMengenHuelle";
    var panel=document.createElement("div");
    panel.className="mmAboMengenPanel";
    panel.setAttribute("aria-label","Abo-Laufzeit auswählen");
    plans.forEach(function(data,i){
      var card=document.createElement("button");
      card.type="button";
      card.className="mmAboMengenOption";
      /* Versatz je Kachel - daraus rechnet das Stilblatt die Verzoegerung,
         damit sie nacheinander einlaufen statt alle auf einmal. */
      card.style.setProperty("--mmAboI",i);
      card.setAttribute("data-mm-plan-id",data.id);
      /* 29.08.2026: Laufzeit als Kennzeichen, damit das Stilblatt die
         Jahres-Kachel ansprechen kann (sie steht allein in der letzten
         Zeile und soll die volle Breite bekommen). */
      card.setAttribute("data-mm-monate",data.months);
      card.setAttribute("aria-pressed","false");
      card.setAttribute("aria-label",data.title+", "+data.deliveries+" monatliche Lieferungen, "+data.discount+" Prozent sparen");
      if(BADGES[data.months])card.setAttribute("data-mm-badge",BADGES[data.months]);
      var total=30*data.deliveries;
      /* 29.08.2026: Rabattzahl und Preis stehen jetzt in eigenen Auszeichnungen.
         Nur so laesst sich die Zahl gross setzen und das Wort "sparen" klein -
         vorher war beides eine Zeichenkette und musste dieselbe Groesse haben. */
      card.innerHTML="<strong>"+data.title+"</strong>"+
        "<span class=\"mmAboSticks\">30 Sticks · "+data.deliveries+" Lieferung"+(data.deliveries===1?"":"en")+"</span>"+
        "<span class=\"mmAboRabatt\">"+(data.discount?"<b class=\"mmAboZahl\">"+data.discount+"&thinsp;%</b> sparen":"Abo-Preis")+"</span>"+
        "<span class=\"mmAboPreis\"><b class=\"mmAboPreisZahl\">"+(data.price||"")+"</b> · "+total+" gesamt</span>";
      card.addEventListener("click",function(event){
        event.preventDefault();
        event.stopPropagation();
        var input=data.input;
        if(input&&!input.checked)input.click();
        window.setTimeout(function(){syncCardState(group,panel,toggle.querySelector(".mmAboMengenAktuell"))},60);
      });
      panel.appendChild(card);
    });
    huelle.appendChild(panel);
    wrap.appendChild(huelle);
    group.appendChild(wrap);
    toggle.addEventListener("click",function(event){
      event.preventDefault();
      event.stopPropagation();
      openPanel(group,toggle,!group.classList.contains("mmAboMengenOffen"));
    });
    group.querySelectorAll('input[data-radio-type="selling_plan"]').forEach(function(input){input.addEventListener("change",function(){syncCardState(group,panel,toggle.querySelector(".mmAboMengenAktuell"))})});
    syncCardState(group,panel,toggle.querySelector(".mmAboMengenAktuell"));
    installAutoOpen(group,toggle);
    return wrap;
  }

  function annotateGroups(container,real){
    container.querySelectorAll(".subscription_group").forEach(function(group,index){
      group.style.setProperty("--mmAboVerzug",.08+.1*index+"s");
      if(group===real)group.classList.add("mmAboReal");
      else if(group.querySelectorAll('input[data-radio-type="selling_plan"]').length)group.setAttribute("data-mm-abo-alt","1");
    });
  }

  function fixedTermNote(container){
    var note=container.querySelector("[class*=polic]");
    if(!note)return;
    note.textContent="Die gewählte Laufzeit umfasst die angezeigte Anzahl monatlicher Lieferungen und endet danach automatisch. Gesetzliche Rechte bleiben unberührt.";
    note.setAttribute("data-mm-abo-policy","fixed-term");
  }

  function prepareAbo(container){
    if(!container)return false;
    container.classList.add("mmAboEng");
    container.removeAttribute("data-mm-abo-set");
    if(isSetPage()){
      container.setAttribute("data-mm-abo-set","1");
      container.style.display="none";
      return "set";
    }
    container.style.removeProperty("display");
    setAccent(container);
    var real=findRealGroup(container);
    if(!real)return false;
    var plans=Array.prototype.slice.call(real.querySelectorAll('input[data-radio-type="selling_plan"]')).map(details).sort(function(a,b){return MONATE.indexOf(a.months)-MONATE.indexOf(b.months)});
    if(plans.length!==7)return false;
    annotateGroups(container,real);
    fixedTermNote(container);
    createChoices(real,plans);
    return true;
  }

  function bestseller(){
    document.querySelectorAll(".bdg strong").forEach(function(label){
      if((label.textContent||"").trim().toLowerCase()!=="bestseller"||!label.parentElement)return;
      var badge=label.parentElement;
      badge.classList.add("mmBestsellerFarbe");
      /* 28.08.2026, Mert: "bestseller verschwindet - es bleibt nach der
         animation". Echter Ablauffehler: Diese Funktion laeuft bei jedem
         Neuaufbau der Karte erneut. Sie nahm dem Abzeichen erst die
         Sichtbarkeit und kehrte wegen der schon gesetzten Merkfahne sofort
         zurueck - der Beobachter, der die Klasse wieder setzt, war da
         laengst getrennt. Das Abzeichen blieb dauerhaft auf opacity:0.
         Jetzt wird beim ZWEITEN Lauf nichts zurueckgenommen, sondern
         sofort wieder sichtbar geschaltet. */
      if(badge.dataset.mmBestsellerAnimation){
        badge.classList.add("mmBestsellerDa");
        return;
      }
      badge.classList.remove("mmBestsellerDa");
      badge.dataset.mmBestsellerAnimation="1";
      var show=function(){badge.classList.add("mmBestsellerDa")};
      /* Sicherheitsnetz: Egal was mit Beobachter oder Sichtbarkeit
         passiert - nach 1,4 s ist das Abzeichen auf jeden Fall da. Ein
         unsichtbares Abzeichen ist schlimmer als eines ohne Einlauf. */
      window.setTimeout(show,1400);
      if("IntersectionObserver"in window&&!window.matchMedia("(prefers-reduced-motion: reduce)").matches){
        var observer=new IntersectionObserver(function(entries){if(entries[0]&&entries[0].isIntersecting){show();observer.disconnect()}},{threshold:.35});
        observer.observe(badge);
      }else show();
    });
  }

  function animateRoot(container){
    if(container.dataset.mmAboAnimation)return;
    container.dataset.mmAboAnimation="1";
    container.classList.add("mmAboAnimBereit");
    var visible=false;
    function update(){
      var on=visible&&!document.hidden;
      container.classList.toggle("mmAboAnimAn",on);
    }
    if("IntersectionObserver"in window&&!window.matchMedia("(prefers-reduced-motion: reduce)").matches){
      new IntersectionObserver(function(entries){visible=!!(entries[0]&&entries[0].isIntersecting);update()},{threshold:.18}).observe(container);
      document.addEventListener("visibilitychange",update);
    }else{visible=true;update()}
  }

  function run(){
    addStyle();
    bestseller();
    var container=findSubscriptionRoot();
    if(!container)return false;
    var ready=prepareAbo(container);
    if(ready===true)animateRoot(container);
    return ready;
  }

  function watch(){
    if(run())return;
    window.clearTimeout(rootTimer);
    rootTimer=window.setTimeout(watch,220);
  }

  function start(){
    watch();
    if("MutationObserver"in window&&document.body&&!document.documentElement.dataset.mmAboV7Watch){
      document.documentElement.dataset.mmAboV7Watch="1";
      var timer=0;
      new MutationObserver(function(){window.clearTimeout(timer);timer=window.setTimeout(function(){run()},80)}).observe(document.body,{childList:true,subtree:true});
      window.addEventListener("popstate",run);
      document.addEventListener("shopify:section:load",run);
    }
  }

  "loading"===document.readyState?document.addEventListener("DOMContentLoaded",start):start();
}();
